"use strict";
/**
 * StandOut WordPress Theme
 * Template-specific functionality initialization
 * Uses body classes to determine current template
 *
 * @package StandOut
 * @since 2.0.0
 */
// Button animations (GSAP entrance — loads on all pages)
import("./button-animations").catch((error) => {
    console.error("Failed to load button animations module:", error);
});
// Default page template
const page = document.getElementsByClassName("page-template-default");
if (page.length > 0) {
    import("./page").catch((error) => {
        console.error("Failed to load page template module:", error);
    });
}
// Contactgegevens Formulier
const contactgegevensFormulier = document.getElementsByClassName("flexible--contactgegevens-formulier");
if (contactgegevensFormulier.length > 0) {
    import("./blocks/contactgegevens-formulier").catch((error) => {
        console.error("Failed to load contactgegevens-formulier module:", error);
    });
}
// Content Met Foto
const contentMetFoto = document.getElementsByClassName("flexible--content-met-foto");
if (contentMetFoto.length > 0) {
    import("./blocks/content-met-foto").catch((error) => {
        console.error("Failed to load content-met-foto module:", error);
    });
}
// Content Twee Fotos
const contentTweeFotos = document.getElementsByClassName("flexible--content-twee-fotos");
if (contentTweeFotos.length > 0) {
    import("./blocks/content-twee-fotos").catch((error) => {
        console.error("Failed to load content-twee-fotos module:", error);
    });
}
// Content Volle Breedte
const contentVolleBreedte = document.getElementsByClassName("flexible--content-volle-breedte");
if (contentVolleBreedte.length > 0) {
    import("./blocks/content-volle-breedte").catch((error) => {
        console.error("Failed to load content-volle-breedte module:", error);
    });
}
// CTA Samen Ondernemen
const ctaSamenOndernemen = document.getElementsByClassName("flexible--cta-samen-ondernemen");
if (ctaSamenOndernemen.length > 0) {
    import("./blocks/cta-samen-ondernemen").catch((error) => {
        console.error("Failed to load cta-samen-ondernemen module:", error);
    });
}
// Hero Intro (header)
const heroIntro = document.getElementsByClassName("flexible-header--hero-intro");
if (heroIntro.length > 0) {
    import("./headers/hero-intro").catch((error) => {
        console.error("Failed to load hero-intro module:", error);
    });
}
// Hero Img (header)
const heroImg = document.getElementsByClassName("flexible-header--hero-img");
if (heroImg.length > 0) {
    import("./headers/hero-img").catch((error) => {
        console.error("Failed to load hero-img module:", error);
    });
}
// Hero Twee Fotos (header)
const heroTweeFotos = document.getElementsByClassName("flexible-header--hero-twee-fotos");
if (heroTweeFotos.length > 0) {
    import("./headers/hero-twee-fotos").catch((error) => {
        console.error("Failed to load hero-twee-fotos module:", error);
    });
}
// Klantreis Intro
const klantreisIntro = document.getElementsByClassName("flexible--klantreis-intro");
if (klantreisIntro.length > 0) {
    import("./blocks/klantreis-intro").catch((error) => {
        console.error("Failed to load klantreis-intro module:", error);
    });
}
// Klantteam
const klantteam = document.getElementsByClassName("flexible--klantteam");
if (klantteam.length > 0) {
    import("./blocks/klantteam").catch((error) => {
        console.error("Failed to load klantteam module:", error);
    });
}
// Logo Wall
const logoWall = document.getElementsByClassName("flexible--logo-wall");
if (logoWall.length > 0) {
    import("./blocks/logo-wall").catch((error) => {
        console.error("Failed to load logo-wall module:", error);
    });
}
// Over Ons
const overOns = document.getElementsByClassName("flexible--over-ons");
if (overOns.length > 0) {
    import("./blocks/over-ons").catch((error) => {
        console.error("Failed to load over-ons module:", error);
    });
}
// Pakketten
const pakketten = document.getElementsByClassName("flexible--pakketten");
if (pakketten.length > 0) {
    import("./blocks/pakketten").catch((error) => {
        console.error("Failed to load pakketten module:", error);
    });
}
// Team Slider
const teamSlider = document.getElementsByClassName("flexible--team-slider");
if (teamSlider.length > 0) {
    import("./blocks/team-slider").catch((error) => {
        console.error("Failed to load team-slider module:", error);
    });
}
// Testimonial Slider
const testimonialSlider = document.getElementsByClassName("flexible--testimonial-slider");
if (testimonialSlider.length > 0) {
    import("./blocks/testimonial-slider").catch((error) => {
        console.error("Failed to load testimonial-slider module:", error);
    });
}
// Vacatures Overzicht
const vacaturesOverzicht = document.getElementsByClassName("flexible--vacatures-overzicht");
if (vacaturesOverzicht.length > 0) {
    import("./blocks/vacatures-overzicht").catch((error) => {
        console.error("Failed to load vacatures-overzicht module:", error);
    });
}
// Werken Bij Intro
const werkenBijIntro = document.getElementsByClassName("flexible--werken-bij-intro");
if (werkenBijIntro.length > 0) {
    import("./blocks/werken-bij-intro").catch((error) => {
        console.error("Failed to load werken-bij-intro module:", error);
    });
}
// Vacature - Office Galerij
const vacatureOfficeGalerij = document.getElementsByClassName("vacature-office-galerij");
if (vacatureOfficeGalerij.length > 0) {
    import("./vacature/office-galerij").catch((error) => {
        console.error("Failed to load vacature office-galerij module:", error);
    });
}
// Vacature - Sollicitatie procedure
const vacatureSollicitatieProcedure = document.getElementsByClassName("vacature-sollicitatie-procedure");
if (vacatureSollicitatieProcedure.length > 0) {
    import("./vacature/sollicitatie-procedure").catch((error) => {
        console.error("Failed to load vacature sollicitatie-procedure module:", error);
    });
}
